module.exports = __webpack_public_path__ + "img/tc9.e66b38d0.png";